function e(){if("undefined"==typeof navigator)return!1;return navigator.userAgent.toLowerCase().includes("android")}export{e as default};
